import React from "react";
import "./App.css";
import Album from "./components/Album";

function App() {
  return (
    <div className="App">
      <Album></Album>
    </div>
  );
}

export default App;
